import { PRICING } from '@wetransfer/transfer/constant/routes';
import { userHasProOrPlusTier } from '@wetransfer/transfer/helper/user';
import { State } from '@wetransfer/transfer/store/types';

export const getDescriptionSizeAlert = (user: State['user']): string => {
  if (userHasProOrPlusTier(user)) {
    return 'upsell_tiers.pro_limit';
  }

  return 'upsell_tiers.free_limit';
};

export const getHrefSizeAlert = (): string => PRICING.route;
